import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './style.scss';
import { bool, instanceOf } from 'prop-types';

function ColouredPill({ data, showIcon }) {
  return (
    <div className="connection-pill" style={{ backgroundColor: data.bgColor }}>
      <If condition={showIcon}>
        <FontAwesomeIcon icon={faCircle} className="connection-pill-circle mr6" style={{ color: data.color }} />
      </If>
      <span className="arc-support" style={{ color: data.color }}>
        {data.label}
      </span>
    </div>
  );
}

ColouredPill.defaultProps = {
  showIcon: true,
};

ColouredPill.propTypes = {
  data: instanceOf(Object).isRequired,
  showIcon: bool,
};

export default ColouredPill;
